import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '-12px',
    minWidth: '340px',
  },
}));